<template>
  <section class="q-pa-md">
    <div class="row justify-center items-center q-gutter-md q-pb-md heading">
      <div class="title">
        <h2 class="text-h4 text-weight-medium no-margin">
          Popular Categories
        </h2>
      </div>
    </div>
    <div class="row q-col-gutter-md justify-center items-center">
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/shooting/guns/handguns">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/handguns.jpg"
              height="250"
              densities="x1 x2"
              fit="crop"
              class="fit"
              alt="Shop handguns at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Handguns
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/shooting/guns/rifles">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/rifles.jpg"
              height="250"
              densities="x1 x2"
              fit="crop"
              class="fit"
              alt="Shop rifles at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Rifles
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/shooting/guns/shotguns">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/shotguns.jpg"
              height="250"
              densities="x1 x2"
              fit="crop"
              class="fit"
              alt="Shop shotguns at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Shotguns
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/ammunition">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/ammunition.jpg"
              height="250"
              densities="x1 x2"
              fit="crop"
              class="fit"
              alt="Shop ammo at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Ammunition
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/shooting/gun-parts">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/gun-parts.jpg"
              height="250"
              densities="x1 x2"
              fit="crop"
              class="fit"
              alt="Shop gun parts & accessories at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Gun Parts
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/optics">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/optics.jpg"
              height="250"
              densities="x1 x2"
              class="fit"
              alt="Shop optics at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Optics
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/knives">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/knives.jpg"
              height="250"
              densities="x1 x2"
              class="fit"
              alt="Shop knives at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Knives
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <nuxt-link to="/category/archery">
          <div
            class="q-img rounded-borders"
            style="height: 200px"
          >
            <NuxtImg
              provider="cloudflare"
              src="/assets/backdrops/archery.jpg"
              height="250"
              densities="x1 x2"
              class="fit"
              alt="Shop archery at KYGUNCO"
              sizes="xs:400px sm:600px"
              style="object-fit: cover; object-position: 50% 50%;"
            />
            <div class="q-img__content absolute-full q-anchor--skip">
              <div class="absolute-bottom text-subtitle2 text-center">
                <h3 class="text-h5 text-weight-medium no-margin">
                  Archery
                </h3>
              </div>
            </div>
          </div>
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>

</script>
